import _styled, { default as _styled2, default as _styled3, default as _styled4 } from "styled-components";
const _excluded = ["style", "className", "title", "illustrationType", "description", "children", "hideIllustration", "size"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import Illustration from '@adsk/alloy-react-illustration';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
const SIZES = {
  MEDIUM: 'medium',
  LARGE: 'large'
};
/**
 * An EmptyState
 * Empty states occur when data is not available to be displayed.
 */
const EmptyState = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      style,
      className,
      title,
      illustrationType = Illustration.TYPES.FOLDER_EMPTY_GREY,
      description,
      children,
      hideIllustration = false,
      size = SIZES.MEDIUM
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const showIllustration = !hideIllustration && illustrationType;
  const illustrationStyle = size === SIZES.LARGE ? {
    height: 250,
    width: 250
  } : undefined;
  return /*#__PURE__*/React.createElement(_StyledDiv, _extends({}, props, {
    className: className,
    ref: ref,
    $_css: [_objectSpread({
      display: 'flex',
      alignItems: 'center',
      textAlign: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      backgroundColor: theme.tokens.colors.background.primary.value,
      color: theme.tokens.colors.text.primary.value,
      boxSizing: 'border-box',
      padding: '20px 40px'
    }, !showIllustration && {
      '> div:first-child': {
        marginTop: 0
      }
    }), style]
  }), showIllustration && /*#__PURE__*/React.createElement(Illustration, {
    type: illustrationType,
    style: illustrationStyle
  }), title && /*#__PURE__*/React.createElement(_StyledDiv2, {
    $_css2: [{
      marginTop: theme.spacing.L
    }, size === SIZES.LARGE ? theme.typography.title : theme.typography.heading2]
  }, title), description && /*#__PURE__*/React.createElement(_StyledDiv3, {
    $_css3: [_objectSpread({
      marginTop: theme.spacing.XS
    }, theme.typography.bodyMedium)]
  }, description), children && /*#__PURE__*/React.createElement(_StyledDiv4, {
    $_css4: [{
      marginTop: theme.spacing.L
    }]
  }, children));
});
EmptyState.displayName = 'EmptyState';
EmptyState.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Empty state title (optional) */
  title: PropTypes.any,
  /** Illustration type */
  illustrationType: PropTypes.oneOf(Object.values(Illustration.TYPES)),
  /** State description */
  description: PropTypes.any,
  /** Additional state content */
  children: PropTypes.any,
  /** Wheteher we should hide the default illustration */
  hideIllustration: PropTypes.bool,
  /** EmptyState size */
  size: PropTypes.oneOf(Object.values(SIZES))
};
export default Object.assign(EmptyState, {
  ILLUSTRATION_TYPES: Illustration.TYPES,
  SIZES
});
var _StyledDiv = _styled("div")`${p => p.$_css}`;
var _StyledDiv2 = _styled2("div")`${p => p.$_css2}`;
var _StyledDiv3 = _styled3("div")`${p => p.$_css3}`;
var _StyledDiv4 = _styled4("div").withConfig({
  displayName: "EmptyState___StyledDiv4",
  componentId: "sc-9lzvm7-0"
})(["", ""], p => p.$_css4);
//# sourceMappingURL=EmptyState.js.map